/*
 * @Author: tianjiaX 
 * @Date: 2019-05-20 15:01:33 
 * @Last Modified by: tianjiaX
 * @Last Modified time: 2019-06-28 16:32:46
 */

 //获取m.lshoot地址
function lshootMLink() {
  var LshootMLink = "http://m.lshoot.com";
  let sitePort = window.location.port;
  if (sitePort) {
    LshootMLink = "http://test.m.lshoot.com:90"
  }
  return LshootMLink;
}

//  添加数组IndexOf方法
if (!Array.prototype.indexOf) {
  Array.prototype.indexOf = function (elt /*, from*/ ) {
    var len = this.length >>> 0;

    var from = Number(arguments[1]) || 0;
    from = (from < 0) ?
      Math.ceil(from) :
      Math.floor(from);
    if (from < 0)
      from += len;

    for (; from < len; from++) {
      if (from in this && this[from] === elt)
        return from;
    }
    return -1;
  };
}

/*ajax全局方法扩展
 *@method   getAjax 
 *@param    {str}       type        获取数据的方法 get/post   默认为get  get需要拼接好url再进行操作
 *@param    {str}       url         ajax的链接
 *@param    {json}      data        传输的数据json
 *@param    {fn}        suceessfn   成功时候的回调
 *@param    {Boolean}   showLoad    显示loading层  true显示 false不显示， 默认为true
 */
function getAjax(type = 'get', url = '', data = {}, suceessfn = null, showLoad = true) {
  debugger
  // console.info('getAjax', data)
  let self = this;
  if (showLoad) {
    self.load(true)
  }
  // 发送 POST 请求
  self.$axios({
      method: type,
      url: url,
      data: self.qs.stringify(data),
      headers: {
        'lshoot-qupaipai-hk-account-token': self.getCookie('lshoot-qupaipai-hk-account-token'),
        'lshoot-qupaipai-terminal-platformtype': 2
      },
    }).then(function (res) {
      self.load(false);
      if (res.data.code < 0) {
        self.tips(res.data.msg);
        return false
      }
      suceessfn && suceessfn(res.data);
      return false
    })
    .catch(function (errRes) {
      self.load(false)
      if (errRes.response) {
        if (errRes.response.code < 0) {
          self.tips(errRes.response.msg);
          return false
        }
        if (errRes.responseJSON && errRes.responseJSON.msg) {
          self.tips(errRes.responseJSON.msg);
          return false;
        }
        self.tips('访问数据失败');
      }
    });
}

/*获取url参数
 *@method   getQueryString 
 *@param    {str}   name    参数的名字
 * @return  {str}   null 或 url该名称的值
 */
function getQueryString(name = '') {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return decodeURI(r[2]);
  return null;
}

/*非空判断
 *@method   isNull
 *@param    {str}   argument    参数 
 * @return   {Boolean}   true 正确  false 错误
 */
function isNull(argument = '') {
  argument = argument.toString().replace(/\s+/g, '')
  if (argument.length === 0) {
    return false
  } else {
    return true
  }
}


/*手机号码校验
 *@method   regPhoneNumber
 *@param    {str}   argument    电话号码 
 * @return   {Boolean}   true 正确  false 错误
 */
function regPhoneNumber(argument = '') {
  let reg = /^[1][1-9][0-9]{9}$/
  argument = argument.replace(/\s+/g, '')
  if (!(reg.test(argument)) || argument.length === 0) {
    return false
  } else {
    return true
  }
}

/*身份证校验
 *@method  regIDFun
 *@param    {str}   argument    身份证号码 
 * @return   {Boolean}   true 正确  false 错误
 */
function regIDFun(argument = '') {
  // 400155192203285333
  let reg15 = /^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}$/,
    reg18 = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
  argument = argument.replace(/\s+/g, '')
  if (argument.length == 15 && reg15.test(argument)) {
    return true
  } else if (argument.length == 18 && reg18.test(argument)) {
    return true
  } else {
    return false
  }
}

/*邮箱校验
 *@method  regmMailboxFun
 *@param    {str}   argument    邮箱 
 * @return   {Boolean}   true 正确  false 错误
 */
function regmMailboxFun(argument = '') {
  // temp@qq.com
  let reg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
  argument = argument.replace(/\s+/g, '');
  if (reg.test(argument)) {
    return true
  } else {
    return false
  }
}

/*时间戳转化
 *@method   timeReplacement
 *@param    {str}   argument    日期 
 * @return  {str}   处理好的时间
 */
function timeReplacement(argument = '') {
  if (argument == null || argument == '') {
    return ''
  }
  let date = new Date(+new Date(argument) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
  return date;

}

/*截断方法
 *@method   cutString
 *@param    {str}       str         字符串 
 *@param    {number}    cutLen      多少字截断
 * @return  {str}   截断后的字符串
 */
function cutString(str, cutLen) {
  if (!str || str.length <= cutLen) {
    return str
  } else {
    return str.substring(0, cutLen) + '...'
  }
}

/*获取城市中文代码
 *@method   timeReplacement
 *@param    {str}   argument    城市id 
 *@param    {str}   DOMID       渲染id 
 * @return  {str}   匹配的城市
 */
function getCityChinese(argument = '', DOMID = '') {
  let cityTime,
    cityRetrun = '';
  cityTime = setInterval(function () {
    if (cityJson.length > 0) {
      for (let index = 0; index < cityJson.length; index++) {
        if (cityJson[index].id == argument) {
          clearInterval(cityTime);
          $('#' + DOMID).val(cityJson[index].areaName)
        }
      }
    }
  }, 1);
}

/*展示大图
 *@method   showBigImg
 *@param    {str}   title        图片标题，默认为 上传预览
 *@param    {str}   imgUrl       图片Url，默认为空
 */
function showBigImg(title = '上传预览', imgUrl = '') {
  layer.photos({
    photos: {
      "title": '', //相册标题
      "id": 123, //相册id
      "start": 0, //初始显示的图片序号，默认0
      "data": [ //相册包含的图片，数组格式
        {
          "alt": title,
          "pid": 666, //图片id
          "src": imgUrl, //原图地址
          "thumb": imgUrl //缩略图地址
        }
      ]
    },
    anim: 5 //0-6的选择，指定弹出图片动画类型，默认随机（请注意，3.0之前的版本用shift参数）
  });
}

/*退出登录状态，并返回首页
 *@method   loginOut 
 */
function loginOut() {
  let self = this;
  // 退出操作
  getAjax(
    'post',
    lshoot.api.account.logout, {},
    function () {
      // 删除cookie
      self.delCookie("lshoot-qupaipai-hk-account-token");
      self.delCookie("lshoot-user-info");
      self.delCookie("openid");
      // 提示
      layer.msg('退出成功', {
        icon: 1,
        time: 2000 //2秒关闭（如果不配置，默认是3秒）
      });
      // 回到登录页
      setTimeout(() => {
        window.location.href = '/login.html'
      }, 1000);
    }
  );
  // 返回到首页
  // window.location.href = '/'
}



export {
  getAjax,
  getQueryString,
  isNull,
  regPhoneNumber,
  regIDFun,
  regmMailboxFun,
  timeReplacement,
  cutString,
  getCityChinese,
  showBigImg,
  loginOut,
  lshootMLink
}



// WEBPACK FOOTER //
// ./src/assets/js/check.js